import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps';

export default class Collapase extends React.Component {
  constructor(props) {
    super(props)

    this.state = { 
      isOpen : false
    }

    this.config = {
      types : [
        {
          title: 'default',
          isDefault: true,
        },
        'inverse'
      ],
      modifiers : [],
      states : []
    }

    this.togglePanel = this.togglePanel.bind(this)
  }

  togglePanel(e){
    const currentState = this.state.isOpen;
    this.setState({ isOpen: !currentState });
    this.props.onClick && this.props.onClick(e)
  }

  render() {
    const { inverse, children, title, ...rest } = this.props
    return <div {...rest} className={resolveProps(this.props, this.config, 'Collapse') + (this.state.isOpen ? ' mdn-Collapse-active ' : ' ') + this.props.className}>
      <div className="mdn-Collapse-box" onClick={this.togglePanel} >
        <a className="mdn-Collapse-toggle mdn-Text mdn-Text--body">
          {title}
          <span className="mdn-Collapse-icon mdn-Icon-baixo mdn-Icon--md"></span>
        </a>      
      </div>
      <div className="mdn-Collapse-content">
        <div className="mdn-Container mdn-u-color--secondary">
          {children}
        </div>
      </div>  
    </div>
  }
}

Collapase.propTypes = {
  children : PropTypes.node,
  title : PropTypes.string,
}